import { useParams } from 'react-router-dom'
import { useEffect, useState } from "react"
import UpdateAdminForm from "../../components/update/update-admin-form"
import { useAuth } from "../../context/AuthProvider";
import { useLanguage } from "../../context/LanguageProvider";
import { toast } from "sonner"
import Loading from "../../cors/Loading"
import { BASE_URL } from '../../apiConfig'

export default function Page() {
  const { token } = useAuth();
  const { t } = useLanguage();
  const { id } = useParams()
  const [currentUserData, setCurrentUserData] = useState(null)
  const [availableRoles, setAvailableRoles] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchData = async () => {
    try {
      const [userResponse, rolesResponse] = await Promise.all([
        fetch(`${BASE_URL}/api/show-admin/${id}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }),
        fetch(`${BASE_URL}/api/role`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
      ])

      if (!userResponse.ok) throw new Error(t('admins.error_fetch_user'))
      if (!rolesResponse.ok) throw new Error(t('admins.error_fetch_roles'))

      const userData = await userResponse.json()
      const rolesData = await rolesResponse.json()

      setCurrentUserData(userData.data)
      setAvailableRoles(rolesData.data || [])
    } catch (error) {
      console.error("Error fetching data:", error)
      toast.error(t('admins.load_error'))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [id])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading />
      </div>
    )
  }

  if (!currentUserData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-red-500">{t('admins.load_error')}</div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4">
        <UpdateAdminForm
          userId={Number(id)}
          currentUserData={currentUserData}
          roles={availableRoles}
          fetchData={fetchData}
        />
      </div>
    </div>
  )
}
